// Dependencias
import Toast from 'typescript-toastify';
import { ToastOptions } from 'typescript-toastify/lib/type/type';

// Utils
import { ValidationsTypes, validInputStyle } from '../utils/stylesInputs';
import { loadLoader } from '../utils/loader';

// Errors
import { AuthError } from '../errors/common.error';
import { ServerError } from '../errors/core.error';

// Config
import * as KEYS from '../config/keys.config';

// Schemas
import {
  emailSchema,
  passwordSchema,
  AuthSchema
} from '../schemas/auth.schema';

// Servicios
import * as authService from '../service/auth.service';
import {
  AuthMessages,
  EmailMessage,
  GenericMessage
} from '../config/Messages.config';

// Elementos HTML
const loginYearElement =
  document.querySelector<HTMLSpanElement>('#login-year')!;
const showPasswordCkeck = document.querySelector<HTMLInputElement>(
  '#show-password-check'
)!;
const emailElement = document.querySelector<HTMLInputElement>(
  '#form-floting-email'
)!;
const passwordElement = document.querySelector<HTMLInputElement>(
  '#form-floting-password'
)!;
const formLoginElemnet =
  document.querySelector<HTMLFormElement>('#form-login')!;
const buttonElement = document.querySelector<HTMLButtonElement>('#btn-login')!;

// Banderas para Activiación de los datos
let isValidEmail = false;
let isValidPassword = false;

/**
 * Valida que las credenciales insertadas por el usuario sean correctas
 */
function validateInputs({ inputType, target }: OptionsValidateInputs) {
  const containerInput = target.parentElement! as HTMLDivElement;
  const inputElement = containerInput.querySelector('input')!;
  const feedbackElement = containerInput.querySelector('span');

  // Se verifica si el valor del input es mayor a 1 dijito, para continuar
  const shouldContinue = inputElement.value.length > 0;
  if (!shouldContinue) {
    validInputStyle({
      type: ValidationsTypes.RESET,
      input: inputElement,
      container: containerInput,
      feedBack: feedbackElement!
    });

    return;
  }

  try {
    // Se valida segun el tipo de input que se tenga
    if (inputType === InputsTypes.EMAIL) {
      emailSchema.parse(inputElement.value);
      isValidEmail = true;

      validInputStyle({
        type: ValidationsTypes.VALID,
        input: inputElement,
        container: containerInput,
        feedBack: feedbackElement!,
        message: EmailMessage.SUCCESS
      });
    }

    if (inputType === InputsTypes.PASSWORD) {
      passwordSchema.parse(inputElement.value);
      isValidPassword = true;

      validInputStyle({
        type: ValidationsTypes.VALID,
        input: inputElement,
        container: containerInput
      });
    }
  } catch {
    // Si existe algun error al validar los squemas
    const isTypeEmail = inputType === InputsTypes.EMAIL;
    if (isTypeEmail) {
      validInputStyle({
        type: ValidationsTypes.INVALID,
        input: inputElement,
        container: containerInput,
        feedBack: feedbackElement!,
        message: EmailMessage.ERROR
      });
      isValidEmail = false;
    }

    const isTypePassword = inputType === InputsTypes.PASSWORD;
    if (isTypePassword) {
      validInputStyle({
        type: ValidationsTypes.INVALID,
        input: inputElement,
        container: containerInput
      });
      isValidPassword = false;
    }

    buttonElement.classList.add('disabled');
    return;
  }

  // Activo el Boton simpre y cuando esten valida las credenciales
  const isValidAuth = isValidEmail && isValidPassword;
  if (isValidAuth) buttonElement.classList.remove('disabled');
  else buttonElement.classList.add('disabled');
}

export function main() {
  // Establece el Año Actual en el Copyrayt
  document.addEventListener('DOMContentLoaded', () => {
    const currentYear = new Date().getFullYear();
    loginYearElement.innerText = `${currentYear}`;
  });

  // Evento para Mostar la contraseña del usuario
  showPasswordCkeck.addEventListener(
    'change',
    () =>
      (passwordElement.type = showPasswordCkeck.checked ? 'text' : 'password')
  );

  // Verificación de correo y contraseña del usuario
  const events = ['keyup', 'change', 'focusout'];
  events.forEach((event) =>
    emailElement.addEventListener(event, (e) =>
      validateInputs({
        inputType: InputsTypes.EMAIL,
        target: e.target as HTMLInputElement
      })
    )
  );
  events.forEach((event) =>
    passwordElement.addEventListener(event, (e) =>
      validateInputs({
        inputType: InputsTypes.PASSWORD,
        target: e.target as HTMLInputElement
      })
    )
  );

  // Funcionalidad de Loggin para la aplicación
  formLoginElemnet.addEventListener('submit', async(e) => {
    e.preventDefault();
    // Variables de configuración
    // Definición de configuración de Toast
    let toastConfig: ToastOptions = {
      type: 'error',
      theme: 'dark',
      position: 'bottom-right',
      showProgress: false,
      canClose: false,
      autoCloseTime: KEYS.TIME_CLOSE_TOAST
    };

    // Se obtienen los datos escritos a los inputs
    const formElementTarget = e.target as HTMLFormElement;
    const authCredentials = Object.fromEntries(
      new FormData(formElementTarget).entries()
    ) as AuthSchema;

    // Inicia la animación de carga
    loadLoader({});

    try {
      // Se realiza auth de la aplicación y si todo sale bien, se redirecciona a la ruta inicial
      await authService.login(authCredentials);
      location.href = '/';
    } catch (error) {
      console.log(error);

      // Se definen el mensaje de error para los mensajes Toast
      if (error instanceof AuthError)
        toastConfig = { ...toastConfig, toastMsg: AuthMessages.ERROR };
      else if (error instanceof ServerError)
        toastConfig = { ...toastConfig, toastMsg: AuthMessages.ERROR_SERVICE };
      else toastConfig = { ...toastConfig, toastMsg: GenericMessage.ERROR };

      // Se define el reset de los inputs
      [emailElement, passwordElement].forEach((element) => {
        // Se obtienen los valores de cada uno de los elementos
        const containerInput = element.parentElement! as HTMLDivElement;
        const inputElement = containerInput.querySelector('input')!;
        const feedbackElement = containerInput.querySelector('span');
        // Se reinician los estilos y valores de los inputs
        inputElement.value = '';
        validInputStyle({
          type: ValidationsTypes.RESET,
          container: containerInput,
          input: inputElement,
          feedBack: feedbackElement || undefined
        });
      });

      new Toast(toastConfig);
      loadLoader({ start: false });
    }
  });
}

// Definicion de tipos e interfaces
enum InputsTypes {
  PASSWORD = 'password',
  EMAIL = 'email',
}
type OptionsValidateInputs = {
  inputType: InputsTypes;
  target: HTMLInputElement;
};
